export const basketBallMessages = {
  '2_1': require('./gb.js'),
  '2_2': require('./big.js')
  // '1_3': require('./en.js'),
  // '1_4': require('./ko.js'),
  // '1_5': require('./th.js'),
  // '1_6': require('./vi.js'),
  // '1_7': require('./ja.js'),
  // '1_8': require('./id.js'),
  // '1_9': require('./fr.js'),
  // '1_10': require('./es.js')
}
